module.exports = __webpack_public_path__ + "img/shopee_9thb_0002.0b18a25a.png";